import React from "react";
import PropTypes from "prop-types";
import { RichText } from "@learningblocks/shared-components/lib/RichText";
import style from "./style.module.scss";

export function Header(props) {
  return (
    <p>
      <RichText
        text={props.text}
        className={`${style.sliderHeader} ${props.className}`}
      />
    </p>
  );
}

Header.propTypes = {
  /**
   * classname
   */
  className: PropTypes.string,
  /**
   * text to be displayed in header
   */
  text: PropTypes.string,
};
